(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bash-cart-studio"] && !Shopify.designMode) return;
  try {
    
/* Keep the cart page and its existing drawer in one native quantity response.
 * Load before preview-controller.js. The preview element starts/stops this helper.
 */
if (!window.BashCartStudioCartSync) {
  window.BashCartStudioCartSync = class BashCartStudioCartSync {
    constructor(scope) {
      this.scope = scope;
      this.patches = [];
      this.generation = 0;
    }

    start() {
      if (this.started) return;
      this.started = true;
      const generation = ++this.generation;
      Promise.all([
        customElements.whenDefined('cart-items'),
        customElements.whenDefined('cart-drawer-items'),
      ]).then(() => {
        if (!this.started || generation !== this.generation || !this.scope.isConnected) return;
        const owner = this;
        for (const name of ['cart-items', 'cart-drawer-items']) {
          this._patch(customElements.get(name).prototype, 'getSectionsToRender', (original) => function () {
            const sections = original.apply(this, arguments);
            return owner._sectionsFor(this, sections);
          });
        }

        // Native product forms ask the drawer which sections to bundle with
        // the add. Include both saved cart page sections in that same response.
        this._patch(customElements.get('cart-drawer').prototype, 'getSectionsToRender', (original) => function () {
          const sections = original.apply(this, arguments);
          return owner._addSectionsFor(this, sections);
        });
        this._patch(customElements.get('cart-drawer').prototype, 'renderContents', (original) => function (state) {
          // Third-party widgets may provide only the native drawer sections.
          // Render additional page sections only when they were returned.
          owner.renderingSections = state?.sections || {};
          try {
            const result = original.apply(this, arguments);
            const main = owner.scope.closest('#MainContent');
            const items = main?.querySelector('cart-items');
            const footer = main?.querySelector('#main-cart-footer');
            if (items && footer) {
              const empty = !items.querySelector('.cart-item');
              items.classList.toggle('is-empty', empty);
              footer.classList.toggle('is-empty', empty);
            }
            return result;
          } finally {
            owner.renderingSections = null;
          }
        });

        // Native cart.js chooses page quantity inputs first when both views exist.
        // Correct only cart focus targets, preserving every other dialog's trap.
        this._patch(window, 'trapFocus', (original) => function (container, elementToFocus) {
          const drawer = owner._drawer();
          if (!drawer || !(container === drawer || drawer.contains(container))) {
            return original.apply(this, arguments);
          }

          if (!drawer.classList.contains('active')) {
            const main = owner.scope.closest('#MainContent');
            const requested = elementToFocus && !drawer.contains(elementToFocus) ? elementToFocus : null;
            const fallback = main?.querySelector('cart-items.is-empty .cart__warnings a') || main;
            const target = requested?.isConnected && requested.getClientRects().length ? requested : fallback;
            if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
            return;
          }

          if (elementToFocus && !drawer.contains(elementToFocus)) {
            const index = elementToFocus.dataset?.index;
            const matchingQuantity = index ? Array.from(drawer.querySelectorAll('.quantity__input'))
              .find((input) => input.dataset.index === index) : null;
            const target = matchingQuantity || drawer.querySelector('.drawer__close') || container;
            const args = Array.from(arguments);
            args[1] = target;
            return original.apply(this, args);
          }
          return original.apply(this, arguments);
        });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            const count = event?.cartData?.item_count;
            const drawer = this._drawer();
            if (!drawer || !Number.isInteger(count) || count < 0) return;
            const main = this.scope.closest('#MainContent');
            const elements = [
              main.querySelector('cart-items'),
              main.querySelector('#main-cart-footer'),
              drawer,
              drawer.querySelector('cart-drawer-items'),
            ];
            elements.forEach((element) => element?.classList.toggle('is-empty', count === 0));
          });
        }
      });
    }

    stop() {
      this.started = false;
      ++this.generation;
      if (this.unsubscribe) this.unsubscribe();
      this.unsubscribe = null;
      for (const patch of this.patches.reverse()) {
        if (patch.object[patch.name] !== patch.wrapper) continue;
        if (patch.descriptor) Object.defineProperty(patch.object, patch.name, patch.descriptor);
        else delete patch.object[patch.name];
      }
      this.patches = [];
    }

    _drawer() {
      if (!this.started || !this.scope.isConnected || !this.scope.closest('#MainContent')) return null;
      return document.querySelector('cart-drawer');
    }

    _addSectionsFor(element, original) {
      const drawer = this._drawer();
      if (!drawer || element !== drawer || !Array.isArray(original)) return original;
      const main = this.scope.closest('#MainContent');
      const items = main.querySelector('#main-cart-items');
      const footer = main.querySelector('#main-cart-footer');
      if (!items?.dataset.id || !footer?.dataset.id) return original;
      const additional = [
        { id: items.dataset.id, selector: '#main-cart-items .js-contents' },
        { id: footer.dataset.id, selector: '#main-cart-footer .js-contents' },
      ];
      const merged = original.map((entry) => ({ ...entry }));
      for (const entry of additional) {
        if (this.renderingSections && typeof this.renderingSections[entry.id] !== 'string') continue;
        if (!merged.some((current) => current.id === entry.id)) merged.push(entry);
      }
      return merged.length <= 5 ? merged : original;
    }

    _sectionsFor(element, original) {
      const drawer = this._drawer();
      if (!drawer || !Array.isArray(original)) return original;
      const main = this.scope.closest('#MainContent');
      if (!main.contains(element) && !drawer.contains(element)) return original;
      const items = main.querySelector('#main-cart-items');
      const footer = main.querySelector('#main-cart-footer');
      if (!items?.dataset.id || !footer?.dataset.id || !document.getElementById('cart-live-region-text')) {
        return original;
      }

      const shared = [
        { id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' },
        { id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' },
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      ];
      const merged = original.map((entry) => ({ ...entry }));
      for (const entry of shared) {
        if (!merged.some((current) => current.id === entry.id)) merged.push(entry);
      }
      // Shopify accepts at most five bundled sections. Leave unexpected third-party
      // section lists alone instead of dropping any of their requested sections.
      return merged.length <= 5 ? merged : original;
    }

    _patch(object, name, createWrapper) {
      const original = object[name];
      if (typeof original !== 'function') return;
      const descriptor = Object.getOwnPropertyDescriptor(object, name);
      if (descriptor && !descriptor.configurable && !descriptor.writable) return;
      const wrapper = createWrapper(original);
      Object.defineProperty(object, name, descriptor
        ? { ...descriptor, value: wrapper }
        : { configurable: true, writable: true, value: wrapper });
      this.patches.push({ object, name, descriptor, wrapper });
    }
  };
}

/* Presentation controls for the separate cart preview. Cart behavior stays native. */
if (!customElements.get('bash-cart-studio')) {
  customElements.define('bash-cart-studio', class BashCartStudio extends HTMLElement {
    connectedCallback() {
      if (this._events) return;
      this._main = this.closest('#MainContent');
      if (!this._main) return;
      this._cartSync = new window.BashCartStudioCartSync(this);
      this._cartSync.start();

      this._events = new AbortController();
      this._links = new Map();
      this._oldWidth = this._main.getAttribute('data-bt-width');
      this._oldDevice = this._main.getAttribute('data-bt-device');
      const options = { signal: this._events.signal };

      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;

        if (button.matches('[data-bt-width]')) {
          const width = button.dataset.btWidth;
          if (!['desktop', 'tablet', 'mobile'].includes(width)) return;
          const url = new URL(window.location.href);
          url.hash = `cart-preview-${width}`;
          window.history.replaceState(window.history.state, '', url);
          this._applyWidth();
        } else if (button.matches('.bt-close')) {
          const url = new URL(window.location.href);
          if (/^#cart-preview-(desktop|tablet|mobile)$/.test(url.hash)) {
            url.hash = '';
            window.history.replaceState(window.history.state, '', url);
          }
          this._applyWidth();
          this._main.focus({ preventScroll: true });
        } else if (button.matches('.bt-open-drawer')) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open(button);
          } else {
            const cartLink = document.getElementById('cart-icon-bubble');
            if (cartLink) cartLink.click();
          }
        }
      }, options);

      window.addEventListener('hashchange', () => this._applyWidth(), options);
      window.addEventListener('popstate', () => {
        this._applyWidth();
        this._decorateCartLinks();
      }, options);

      this._resize = new ResizeObserver(() => this._measure());
      this._resize.observe(this._main);

      // The native drawer and header bubble replace markup after cart changes.
      // Watch only child lists, so updating link attributes cannot retrigger us.
      this._mutations = new MutationObserver((records) => {
        const addsLinks = records.some((record) => Array.from(record.addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches('a[href]') || node.querySelector('a[href]'))
        ));
        if (addsLinks) {
          this._queueLinkDecoration();
        }
      });
      this._mutations.observe(document.body, { childList: true, subtree: true });

      this._applyWidth();
      this._decorateCartLinks();
    }

    disconnectedCallback() {
      if (!this._events) return;
      this._cartSync?.stop();
      this._events.abort();
      this._events = null;
      this._resize.disconnect();
      this._mutations.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
      this._frame = 0;

      for (const [link, values] of this._links) {
        if (link.getAttribute('href') === values.decorated) {
          link.setAttribute('href', values.original);
        }
      }
      this._links.clear();

      this._restoreAttribute('data-bt-width', this._oldWidth);
      this._restoreAttribute('data-bt-device', this._oldDevice);
      this._main = null;
    }

    _restoreAttribute(name, value) {
      if (value === null) this._main.removeAttribute(name);
      else this._main.setAttribute(name, value);
    }

    _applyWidth() {
      const match = window.location.hash.match(/^#cart-preview-(desktop|tablet|mobile)$/);
      const width = match ? match[1] : null;
      const toolbar = this.querySelector('.bt-preview');
      if (toolbar) toolbar.hidden = !width;
      if (width) this._main.dataset.btWidth = width;
      else this._main.removeAttribute('data-bt-width');
      this.querySelectorAll('button[data-bt-width]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.btWidth === width));
      });
      this._measure();
    }

    _measure() {
      const width = this._main.getBoundingClientRect().width;
      this._main.dataset.btDevice = width < 750 ? 'mobile' : width < 1050 ? 'tablet' : 'desktop';
    }

    _queueLinkDecoration() {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = 0;
        if (this.isConnected) this._decorateCartLinks();
      });
    }

    _decorateCartLinks() {
      const page = new URL(window.location.href);
      const isPreview = page.searchParams.get('view') === 'cart-studio';
      const cartPath = new URL(window.routes?.cart_url || '/cart', page).pathname.replace(/\/$/, '');

      for (const [link, values] of this._links) {
        if (!link.isConnected) {
          this._links.delete(link);
        } else if (!isPreview) {
          if (link.getAttribute('href') === values.decorated) {
            link.setAttribute('href', values.original);
          }
          this._links.delete(link);
        } else if (link.getAttribute('href') !== values.decorated) {
          this._links.delete(link);
        }
      }
      if (!isPreview) return;

      document.querySelectorAll('a[href]').forEach((link) => {
        if (this._links.has(link) || link.hasAttribute('download')) return;
        const original = link.getAttribute('href');
        if (!original || original.startsWith('#')) return;
        let url;
        try { url = new URL(original, window.location.href); } catch (_) { return; }
        const path = url.pathname.replace(/\/$/, '');
        if (url.origin !== page.origin || (path !== cartPath && path !== '/cart')) return;
        if (url.searchParams.has('checkout') || url.searchParams.has('view')) return;
        url.searchParams.set('view', 'cart-studio');
        const decorated = `${url.pathname}${url.search}${url.hash}`;
        this._links.set(link, { original, decorated });
        link.setAttribute('href', decorated);
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bash-collection-studio"] && !Shopify.designMode) return;
  try {
    
(() => {
  const elementName = 'bash-collection-studio';
  const registryKey = Symbol.for('bash.collectionStudio.facets');
  const widthPattern = /^#collection-preview-(desktop|tablet|mobile)$/;

  if (customElements.get(elementName)) return;

  class BashCollectionStudio extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return;
      this._main = this.closest('main');
      if (!this._main) return;

      this._mounted = true;
      const lifecycle = new AbortController();
      this._lifecycle = lifecycle;
      const current = new URL(window.location.href);
      this._pathname = current.pathname;
      this._context = new Map();
      for (const key of ['view', 'pb', 'preview_theme_id']) {
        if (current.searchParams.has(key)) this._context.set(key, current.searchParams.get(key));
      }
      this._query = /\/collections\/(types|vendors)\/?$/.test(current.pathname)
        ? current.searchParams.get('q')
        : null;

      this._main.addEventListener('click', (event) => this._onClick(event), {
        signal: lifecycle.signal,
      });
      window.addEventListener('hashchange', () => this._syncWidth(), {
        signal: lifecycle.signal,
      });
      window.addEventListener('popstate', () => this._syncWidth(), {
        signal: lifecycle.signal,
      });

      this._observer = new MutationObserver(() => this._scheduleLinks());
      this._observer.observe(this._main, { childList: true, subtree: true });
      this._resizeObserver = new ResizeObserver(() => this._syncDevice());
      this._resizeObserver.observe(this._main);
      this._syncWidth();
      this._decorateLinks();

      customElements.whenDefined('facet-filters-form').then(() => {
        if (lifecycle.signal.aborted || !this.isConnected || !this._mounted) return;
        this._attachFacets(customElements.get('facet-filters-form'));
      });
    }

    disconnectedCallback() {
      if (!this._mounted) return;
      this._mounted = false;
      this._lifecycle.abort();
      this._observer.disconnect();
      this._resizeObserver.disconnect();
      if (this._linksFrame) cancelAnimationFrame(this._linksFrame);
      this._linksFrame = 0;

      const registry = this._facetRegistry;
      if (registry) {
        registry.owners.delete(this);
        if (!registry.owners.size) {
          if (registry.Facets.renderPage === registry.wrappedRender) {
            registry.Facets.renderPage = registry.originalRender;
          }
          if (registry.Facets.updateURLHash === registry.wrappedUpdate) {
            registry.Facets.updateURLHash = registry.originalUpdate;
          }
        }
      }
      this._facetRegistry = null;

      if (!this._main.querySelector(elementName)) {
        delete this._main.dataset.bcWidth;
        delete this._main.dataset.bcDevice;
      }
    }

    _onClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      const control = target?.closest('[data-bc-width], .bc-close');
      if (!control || !control.closest('.bc-preview') || !this._main.contains(control)) return;

      const width = control.dataset.bcWidth;
      if (!control.classList.contains('bc-close') && !['desktop', 'tablet', 'mobile'].includes(width)) return;
      event.preventDefault();
      const url = new URL(window.location.href);
      url.hash = control.classList.contains('bc-close') ? '' : `collection-preview-${width}`;
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      this._syncWidth();
    }

    _syncWidth() {
      const width = window.location.hash.match(widthPattern)?.[1];
      if (width) this._main.dataset.bcWidth = width;
      else delete this._main.dataset.bcWidth;

      this._main.querySelectorAll('.bc-preview').forEach((controls) => {
        controls.hidden = !width;
        controls.querySelectorAll('[data-bc-width]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.bcWidth === width));
        });
      });
      this._syncDevice();
      this._scheduleLinks();
    }

    _syncDevice() {
      if (!this._mounted) return;
      const width = this._main.getBoundingClientRect().width;
      const device = width < 750 ? 'mobile' : width < 1050 ? 'tablet' : 'desktop';
      if (this._main.dataset.bcDevice !== device) this._main.dataset.bcDevice = device;
    }

    _preserveParams(searchParams) {
      const params = new URLSearchParams(searchParams || '');
      for (const [key, value] of this._context) params.set(key, value);
      if (this._query && !params.has('q')) params.set('q', this._query);
      return params;
    }

    _scheduleLinks() {
      if (!this._mounted || this._linksFrame) return;
      this._linksFrame = requestAnimationFrame(() => {
        this._linksFrame = 0;
        if (this._mounted) this._decorateLinks();
      });
    }

    _decorateLinks() {
      const selector = [
        '#ProductGridContainer .pagination-wrapper a[href]',
        'facet-remove a[href]',
        '#ProductGridContainer .collection--empty a[href]',
      ].join(',');
      this._main.querySelectorAll(selector).forEach((anchor) => {
        const url = new URL(anchor.href, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== this._pathname) return;
        url.search = this._preserveParams(url.searchParams).toString();
        if (anchor.closest('facet-remove')) url.hash = '';
        else if (widthPattern.test(window.location.hash)) url.hash = window.location.hash;
        else if (widthPattern.test(url.hash)) url.hash = '';
        if (anchor.href !== url.href) anchor.href = url.href;
      });
    }

    _attachFacets(Facets) {
      if (typeof Facets?.renderPage !== 'function' || typeof Facets.updateURLHash !== 'function') return;
      let registry = Facets[registryKey];
      if (!registry) {
        registry = {
          Facets,
          owners: new Set(),
          originalRender: Facets.renderPage,
          originalUpdate: Facets.updateURLHash,
        };
        const activeOwner = () => Array.from(registry.owners).reverse().find((owner) => (
          owner._mounted && owner.isConnected && owner._pathname === window.location.pathname
        ));

        registry.wrappedRender = function (searchParams, event, updateURLHash = true) {
          const owner = activeOwner();
          const params = owner ? owner._preserveParams(searchParams).toString() : searchParams;
          return registry.originalRender.call(this, params, event, updateURLHash);
        };
        registry.wrappedUpdate = function (searchParams) {
          const owner = activeOwner();
          const hash = owner ? window.location.hash : '';
          const params = owner ? owner._preserveParams(searchParams).toString() : searchParams;
          const result = registry.originalUpdate.call(this, params);
          if (hash && window.location.hash !== hash) {
            const url = new URL(window.location.href);
            url.hash = hash;
            history.replaceState(history.state, '', url.pathname + url.search + url.hash);
          }
          return result;
        };
        Facets[registryKey] = registry;
      }

      registry.owners.add(this);
      if (Facets.renderPage === registry.originalRender) Facets.renderPage = registry.wrappedRender;
      if (Facets.updateURLHash === registry.originalUpdate) Facets.updateURLHash = registry.wrappedUpdate;
      this._facetRegistry = registry;
    }
  }

  customElements.define(elementName, BashCollectionStudio);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bash-home-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bash-home-hero'))customElements.define('bash-home-hero',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.main=this.closest('main');this.toolbar=this.querySelector('.bh-preview-bar');if(!this.toolbar)return;
    this.onHash=()=>this.updatePreview();window.addEventListener('hashchange',this.onHash);
    this.querySelectorAll('[data-home-width]').forEach(button=>button.addEventListener('click',()=>{const url=new URL(location.href);url.hash='home-preview-'+button.dataset.homeWidth;url.searchParams.set('preview_theme_id',this.dataset.themeId);history.replaceState(null,'',url);this.updatePreview();}));
    this.querySelector('.bh-preview-close').addEventListener('click',()=>{const url=new URL(location.href);url.hash='';this.previewMode=null;history.replaceState(null,'',url);this.updatePreview();});
    this.updatePreview();
  }
  updatePreview(){
    const hashMatch=location.hash.match(/^#home-preview-(desktop|tablet|mobile)$/);if(hashMatch)this.previewMode=hashMatch[1];const match=this.previewMode?[null,this.previewMode]:null;this.toolbar.hidden=!match;
    if(match)this.main.dataset.bhPreviewWidth=match[1];else delete this.main.dataset.bhPreviewWidth;
    requestAnimationFrame(()=>window.dispatchEvent(new Event('resize')));
    this.querySelectorAll('[data-home-width]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.homeWidth===(match?match[1]:'desktop'))));
    this.querySelectorAll('[data-home-design]').forEach(link=>{if(link.dataset.homeDesign===this.dataset.design)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');const target=new URL(link.href);target.hash='home-preview-'+(match?match[1]:'desktop');link.href=target;});
    if(match){const url=new URL(location.href);url.searchParams.set('preview_theme_id',this.dataset.themeId);history.replaceState(null,'',url);}
  }
  disconnectedCallback(){window.removeEventListener('hashchange',this.onHash);if(this.main)delete this.main.dataset.bhPreviewWidth;this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bash-pdp-design"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bash-pdp-design'))customElements.define('bash-pdp-design',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.main=this.closest('main');this.bar=this.querySelector('.bp-preview-bar');
    this.hashListener=()=>this.updatePreview();window.addEventListener('hashchange',this.hashListener);
    this.querySelectorAll('[data-pdp-width]').forEach(button=>button.addEventListener('click',()=>{const url=new URL(location.href);url.hash='pdp-preview-'+button.dataset.pdpWidth;url.searchParams.set('preview_theme_id',this.dataset.themeId);history.replaceState(null,'',url);this.updatePreview();}));
    this.querySelector('.bp-close').addEventListener('click',()=>{this.mode=null;const url=new URL(location.href);url.hash='';history.replaceState(null,'',url);this.updatePreview();});
    this.updatePreview();customElements.whenDefined('product-info').then(()=>{if(this.isConnected)this.prepareNativeProduct();});
  }
  updatePreview(){
    const match=location.hash.match(/^#pdp-preview-(desktop|tablet|mobile)$/);if(match)this.mode=match[1];this.bar.hidden=!this.mode;
    if(this.mode)this.main.dataset.bpWidth=this.mode;else delete this.main.dataset.bpWidth;
    this.querySelectorAll('[data-pdp-width]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pdpWidth===(this.mode||'desktop'))));
    this.querySelectorAll('[data-pdp-design]').forEach(a=>{if(a.dataset.pdpDesign===this.dataset.design)a.setAttribute('aria-current','page');else a.removeAttribute('aria-current');const url=new URL(a.href);url.hash='pdp-preview-'+(this.mode||'desktop');a.href=url;});
    if(this.mode){const url=new URL(location.href);url.searchParams.set('preview_theme_id',this.dataset.themeId);history.replaceState(null,'',url);}
    requestAnimationFrame(()=>window.dispatchEvent(new Event('resize')));
  }
  prepareNativeProduct(){
    const info=this.main.querySelector('product-info');const view=this.dataset.view;if(!info||!view||info.bpPrepared)return;info.bpPrepared=true;
    const addView=url=>{const target=new URL(url,location.origin);target.searchParams.set('view',view);target.searchParams.set('preview_theme_id',this.dataset.themeId);return target;};
    const nativeBuild=info.buildRequestUrlWithParams;const nativeUpdate=info.updateURL;
    if(nativeBuild)info.buildRequestUrlWithParams=function(...args){return addView(nativeBuild.apply(this,args)).toString();};
    if(nativeUpdate)info.updateURL=function(url,variantId){nativeUpdate.call(this,url,variantId);const target=addView(location.href);history.replaceState(null,'',target);};
    const nativeRules=info.fetchQuantityRules;
    if(nativeRules)info.fetchQuantityRules=function(){const id=this.productForm?.variantIdInput?.value;if(!id)return;const spinner=this.querySelector('.quantity__rules-cart .loading__spinner');spinner?.classList.remove('hidden');const url=addView(this.dataset.url);url.searchParams.set('variant',id);url.searchParams.set('section_id',this.dataset.section);return fetch(url).then(r=>r.text()).then(t=>{const html=new DOMParser().parseFromString(t,'text/html');if(html.getElementById('Quantity-Form-'+this.dataset.section))this.updateQuantityRules(this.dataset.section,html);}).catch(e=>console.error(e)).finally(()=>spinner?.classList.add('hidden'));};
  }
  disconnectedCallback(){window.removeEventListener('hashchange',this.hashListener);if(this.main)delete this.main.dataset.bpWidth;this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bash-pdp-refinement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bash-pdp-refinement')) {
  customElements.define('bash-pdp-refinement', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.main = this.closest('main');
      const template = this.querySelector('[data-bpr-dock-template]');
      if (!this.main || !template?.content?.firstElementChild) return;
      this.controller = new AbortController();
      this.dock = template.content.firstElementChild.cloneNode(true);
      this.dock.hidden = true;
      this.dock.inert = true;
      this.dock.dataset.eligible = 'false';
      this.dock.dataset.bprOwner = this.closest('.shopify-section')?.id || 'studio-refinement';
      this.css(this.dock, '--bpr-accent', this.dataset.accent || '#2c493d');
      document.body.append(this.dock);
      this.addButton = this.dock.querySelector('[data-bpr-add]');
      this.editButton = this.dock.querySelector('[data-bpr-edit]');
      this.priceNode = this.dock.querySelector('[data-bpr-price]');
      this.selectionNode = this.dock.querySelector('[data-bpr-selection]');
      this.quantityGroup = this.dock.querySelector('[data-bpr-quantity]');
      this.quantityMinus = this.dock.querySelector('[data-bpr-minus]');
      this.quantityPlus = this.dock.querySelector('[data-bpr-plus]');
      this.quantityValue = this.dock.querySelector('[data-bpr-quantity-value]');
      this.quantityLabel = this.dock.querySelector('[data-bpr-quantity-label]');
      this.labelNode = this.dock.querySelector('[data-bpr-button-label]');
      this.messageNode = this.dock.querySelector('[data-bpr-message]');
      this.mobileQuery = matchMedia('(max-width: 749px)');
      this.keyboardViewportWidth = document.documentElement.clientWidth;
      this.keyboardViewportHeight = Math.max(window.innerHeight, window.visualViewport?.height || 0);
      this.dockHeight = 84;
      this.unsubscribers = [];
      this.schedule = this.schedule.bind(this);
      const options = { signal: this.controller.signal };
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, options);
      window.addEventListener('pageshow', this.schedule, options);
      window.addEventListener('hashchange', this.schedule, options);
      window.visualViewport?.addEventListener('resize', this.schedule, options);
      window.visualViewport?.addEventListener('scroll', this.schedule, { ...options, passive: true });
      this.mobileQuery.addEventListener('change', this.schedule, options);
      document.addEventListener('focusin', this.schedule, options);
      document.addEventListener('focusout', this.schedule, options);
      document.addEventListener('toggle', this.schedule, { ...options, capture: true });
      document.addEventListener('transitionend', this.schedule, options);
      this.main.addEventListener('input', this.schedule, options);
      this.main.addEventListener('change', this.schedule, options);
      this.main.addEventListener('product-info:loaded', this.schedule, options);
      this.addButton?.addEventListener('click', () => this.submit(), options);
      this.editButton?.addEventListener('click', () => this.edit(), options);
      this.quantityMinus?.addEventListener('click', () => this.changeQuantity(-1), options);
      this.quantityPlus?.addEventListener('click', () => this.changeQuantity(1), options);
      this.observer = new MutationObserver((records) => {
        if (records.some(({ target }) => !this.dock.contains(target))) this.schedule();
      });
      this.observer.observe(document.body, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['class', 'style', 'open', 'hidden', 'disabled', 'readonly', 'aria-disabled', 'aria-hidden', 'aria-expanded', 'value', 'min', 'max', 'step', 'data-min', 'data-max', 'data-bp-width']
      });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.main);
      this.resizeObserver.observe(this.dock);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        ['variantChange', 'quantityUpdate', 'cartUpdate', 'cartError'].forEach((name) => {
          if (PUB_SUB_EVENTS[name]) this.unsubscribers.push(subscribe(PUB_SUB_EVENTS[name], this.schedule));
        });
      }
      customElements.whenDefined('product-form').then(() => {
        if (this.isConnected) this.schedule();
      });
      this.schedule();
    }

    text(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }

    attribute(node, name, value) {
      if (node && node.getAttribute(name) !== value) node.setAttribute(name, value);
    }

    css(node, name, value) {
      if (node && node.style.getPropertyValue(name) !== value) node.style.setProperty(name, value);
    }

    schedule() {
      if (this.frame || !this.controller) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.isConnected && this.controller) this.sync();
      });
    }

    nativeState() {
      const info = this.main.querySelector('product-info');
      const component = info?.querySelector('product-form');
      const form = component?.querySelector('form');
      const button = component?.querySelector('button[name="add"]');
      if (!info || !form || !button) return null;
      const quantity = info.querySelector('.quantity__input');
      const variant = form.querySelector('[name="id"]');
      const priceRoot = info.querySelector('[id^="price-"]');
      const price = priceRoot?.querySelector('.price');
      const priceItem = price?.querySelector(price.classList.contains('price--on-sale')
        ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
      const priceText = priceRoot && !priceRoot.classList.contains('hidden')
        ? priceItem?.textContent.trim().replace(/\s+/g, ' ') || '' : '';
      const selections = [...info.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select')]
        .map((input) => input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent.trim() : input.value)
        .filter(Boolean);
      const qty = quantity?.value || '1';
      const errorWrapper = component.querySelector('.product-form__error-message-wrapper');
      const error = errorWrapper && !errorWrapper.hidden
        ? errorWrapper.querySelector('.product-form__error-message')?.textContent.trim() || '' : '';
      const busy = button.classList.contains('loading') || button.getAttribute('aria-busy') === 'true';
      const disabled = button.disabled || button.getAttribute('aria-disabled') === 'true' || !variant?.value;
      const visibleLabel = [...button.querySelectorAll('span')].find((span) =>
        !span.classList.contains('hidden') && !span.closest('.loading__spinner') && span.textContent.trim());
      return { info, component, form, button, quantity, variant, priceText, selections, qty,
        error, errorWrapper, busy, disabled, nativeLabel: visibleLabel?.textContent.trim() || button.textContent.trim() };
    }

    connectErrorReporter(component) {
      if (this.errorComponent === component && this.errorEventName) return;
      this.restoreErrorReporter();
      const ErrorEvent = window.StandardEvents?.CartErrorEvent;
      if (typeof ErrorEvent !== 'function') return;
      let type;
      try { type = new ErrorEvent({ error: '', code: 'SERVICE_UNAVAILABLE' }).type; }
      catch (_) { return; }
      if (!type) return;
      const listener = () => {
        if (!this.submittedHere) return;
        this.localError = this.dataset.errorLabel || 'We couldn’t add this item. Please try again.';
        this.schedule();
      };
      component.addEventListener(type, listener);
      this.errorComponent = component;
      this.errorEventName = type;
      this.errorListener = listener;
    }

    quantityState(state) {
      const input = state?.quantity;
      if (!input) return null;
      const number = (value, fallback) => value !== null && value !== '' && Number.isFinite(Number(value)) ? Number(value) : fallback;
      const min = number(input.getAttribute('min'), 1);
      const max = number(input.getAttribute('max'), Infinity);
      const nativeStep = number(input.getAttribute('step'), 1);
      const step = nativeStep > 0 ? nativeStep : 1;
      const value = number(input.value, min);
      const component = input.closest('quantity-input') || input.parentElement;
      const minus = component?.querySelector('button[name="minus"]');
      const plus = component?.querySelector('button[name="plus"]');
      const blocked = state.disabled || state.busy || this.submitQueued || input.disabled || input.readOnly;
      const buttonBlocked = (button) => button?.disabled || button?.getAttribute('aria-disabled') === 'true' || button?.classList.contains('disabled');
      return {
        input, min, max, step, value, minus, plus,
        minusDisabled: Boolean(blocked || value <= min || buttonBlocked(minus)),
        plusDisabled: Boolean(blocked || value >= max || buttonBlocked(plus))
      };
    }

    syncQuantity(state) {
      const quantity = this.quantityState(state);
      if (this.quantityGroup && this.quantityGroup.hidden !== !quantity) this.quantityGroup.hidden = !quantity;
      this.attribute(this.dock, 'data-has-quantity', String(Boolean(quantity)));
      if (!quantity) return;
      this.text(this.quantityLabel, this.dataset.qtyLabel || 'Qty');
      this.text(this.quantityValue, state.qty);
      this.attribute(this.quantityGroup, 'data-min', String(quantity.min));
      this.attribute(this.quantityGroup, 'data-max', Number.isFinite(quantity.max) ? String(quantity.max) : '');
      this.attribute(this.quantityGroup, 'data-step', String(quantity.step));
      if (this.quantityMinus && this.quantityMinus.disabled !== quantity.minusDisabled) this.quantityMinus.disabled = quantity.minusDisabled;
      if (this.quantityPlus && this.quantityPlus.disabled !== quantity.plusDisabled) this.quantityPlus.disabled = quantity.plusDisabled;
    }

    changeQuantity(direction) {
      const state = this.nativeState();
      const quantity = this.quantityState(state);
      if (!quantity || (direction > 0 ? quantity.plusDisabled : quantity.minusDisabled)) return;
      const nativeButton = direction > 0 ? quantity.plus : quantity.minus;
      if (nativeButton) {
        nativeButton.click();
      } else {
        const previous = quantity.input.value;
        try {
          if (direction > 0) quantity.input.stepUp();
          else quantity.input.stepDown();
        } catch (_) { return; }
        if (quantity.input.value !== previous) quantity.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.localError = '';
      this.syncQuantity(this.nativeState());
      this.schedule();
    }

    restoreErrorReporter() {
      if (this.errorComponent && this.errorEventName) this.errorComponent.removeEventListener(this.errorEventName, this.errorListener);
      this.errorComponent = null;
      this.errorEventName = null;
    }

    isVisible(element) {
      if (!element || element.hidden || !element.getClientRects().length) return false;
      const style = getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    }

    overlayOpen() {
      const selectors = [
        'cart-drawer.active', 'cart-notification.active', 'product-modal[open]', 'modal-dialog[open]',
        'dialog[open]', 'quick-add-modal[open]', 'header-drawer details[open]',
        'details-modal details[open]', '.menu-drawer-container[open]',
        '[aria-modal="true"]', '#shopify-pc__banner', '#reamaze-lightbox', '.reamaze-lightbox',
        '#reamaze-widget-container iframe', '#reamazejs-container iframe',
        '#reamaze-widget-container [role="dialog"]', '#reamazejs-container [role="dialog"]'
      ];
      return [...document.querySelectorAll(selectors.join(','))].some((element) => {
        if (!this.isVisible(element) || element.closest('[aria-hidden="true"]')) return false;
        const cart = element.closest('cart-drawer, cart-notification');
        if (cart && !cart.classList.contains('active')) return false;
        const nativeModal = element.closest('product-modal, modal-dialog, quick-add-modal, dialog');
        if (nativeModal && !nativeModal.hasAttribute('open')) return false;
        const details = element.closest('details');
        if (details && !details.open) return false;
        if (element.tagName === 'IFRAME' && element.closest('#reamaze-widget-container, #reamazejs-container')) {
          const bounds = element.getBoundingClientRect();
          return bounds.width > 180 && bounds.height > 160;
        }
        return true;
      });
    }

    textEntryFocused() {
      const active = document.activeElement;
      if (!this.mobileQuery.matches) return false;
      const viewport = window.visualViewport;
      const viewportHeight = viewport?.height || window.innerHeight;
      const layoutWidth = document.documentElement.clientWidth;
      if (Math.abs(layoutWidth - this.keyboardViewportWidth) > 80) {
        this.keyboardViewportWidth = layoutWidth;
        this.keyboardViewportHeight = Math.max(window.innerHeight, viewportHeight);
      }
      const editing = active && !this.dock.contains(active) && !active.readOnly && !active.disabled && (
        active.isContentEditable || active.matches('textarea, input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]):not([type="range"]):not([type="color"])')
      );
      if ((viewport?.scale || 1) > 1.05) return false;
      this.keyboardViewportHeight = Math.max(this.keyboardViewportHeight, window.innerHeight, viewportHeight);
      if (!editing) return false;
      if ((navigator.virtualKeyboard?.boundingRect?.height || 0) > 0) return true;
      const lostHeight = this.keyboardViewportHeight - viewportHeight;
      return lostHeight > Math.max(120, this.keyboardViewportHeight * 0.18);
    }

    sync() {
      const state = this.nativeState();
      const mode = this.main.dataset.bpWidth;
      const eligible = this.dataset.stickyEnabled !== 'false' && (mode ? mode === 'mobile' : this.mobileQuery.matches);
      this.attribute(this.dock, 'data-eligible', String(eligible));
      const label = this.main.querySelector('.bp-preview-label');
      this.text(label, 'STUDIO REFINEMENT');
      const oldNav = this.main.querySelector('.bp-preview-bar nav');
      if (oldNav && !oldNav.hidden) oldNav.hidden = true;
      if (!state || !eligible) { this.setVisible(false); this.resetChatOffset(); return; }
      this.connectErrorReporter(state.component);
      if (this.submitQueued && state.busy) this.sawNativeBusy = true;
      if (this.submitQueued && this.sawNativeBusy && !state.busy) this.submitQueued = false;
      if (this.submitQueued && state.error) this.submitQueued = false;
      if (this.lastVariant !== undefined && this.lastVariant !== state.variant?.value) this.localError = '';
      this.lastVariant = state.variant?.value;
      const busy = state.busy || this.submitQueued;
      const buttonLabel = busy ? this.dataset.addingLabel || 'Adding…'
        : state.disabled ? state.nativeLabel || this.dataset.unavailableLabel || 'Unavailable'
          : this.dataset.addLabel || 'Add to cart';
      this.text(this.labelNode, buttonLabel);
      this.text(this.priceNode, state.priceText);
      const selection = state.selections.join(' / ');
      this.text(this.selectionNode, selection ? `${selection} · ${this.dataset.optionsLabel || 'Edit'}` : '');
      if (this.editButton && this.editButton.hidden !== !selection) this.editButton.hidden = !selection;
      this.attribute(this.editButton, 'aria-label', `${this.dataset.optionsLabel || 'Edit options'}: ${selection}`);
      this.syncQuantity(state);
      this.attribute(this.addButton, 'aria-label', `${buttonLabel}: ${this.dataset.productTitle || ''}`.replace(/: $/, ''));
      this.attribute(this.addButton, 'aria-busy', String(Boolean(busy)));
      const hasPopup = state.button.getAttribute('aria-haspopup');
      if (hasPopup) this.attribute(this.addButton, 'aria-haspopup', hasPopup);
      if (this.addButton.disabled !== Boolean(state.disabled || busy)) this.addButton.disabled = Boolean(state.disabled || busy);
      const error = state.error || this.localError || '';
      this.text(this.messageNode, error);
      if (this.messageNode.hidden !== !error) this.messageNode.hidden = !error;
      const nativeAnnounces = Boolean(state.error && (state.errorWrapper?.matches('[role="alert"], [aria-live]') || state.errorWrapper?.querySelector('[role="alert"], [aria-live]')));
      this.attribute(this.messageNode, 'aria-live', nativeAnnounces ? 'off' : 'polite');
      const rect = this.main.getBoundingClientRect();
      const preview = mode === 'mobile';
      this.attribute(this.dock, 'data-preview', String(preview));
      this.css(this.dock, '--bpr-dock-left', preview ? `${Math.max(0, rect.left)}px` : '0px');
      this.css(this.dock, '--bpr-dock-width', preview ? `${Math.min(rect.width, document.documentElement.clientWidth)}px` : '100%');
      const overlay = this.overlayOpen();
      const cartOpen = [...document.querySelectorAll('cart-drawer.active, cart-notification.active')].some((cart) => this.isVisible(cart));
      if (cartOpen && this.submittedHere) this.restoreDockFocus = true;
      const nativeRect = state.button.getBoundingClientRect();
      const keyboard = this.textEntryFocused();
      const viewportTop = window.visualViewport?.offsetTop || 0;
      const viewportBottom = viewportTop + (window.visualViewport?.height || window.innerHeight);
      const nativeBelowViewport = this.dataset.initialCta !== 'false' && nativeRect.bottom > viewportBottom;
      const visible = eligible && this.isVisible(state.button) && (nativeRect.bottom < viewportTop || nativeBelowViewport) && !overlay && !keyboard;
      const activeDockControl = this.dock.contains(document.activeElement) ? document.activeElement : null;
      if (!visible && activeDockControl && eligible && !overlay && !keyboard && nativeRect.bottom >= viewportTop && nativeRect.top < viewportBottom) {
        const target = this.quantityGroup?.contains(activeDockControl)
          ? state.quantity || state.button
          : activeDockControl === this.editButton
            ? state.info.querySelector('variant-selects select, variant-selects input:checked, variant-selects input') || state.quantity || state.button
            : state.button.disabled ? state.quantity : state.button;
        target?.focus({ preventScroll: true });
      }
      this.setVisible(visible);
      if (visible) {
        const height = Math.ceil(this.dock.getBoundingClientRect().height);
        if (height) this.dockHeight = height;
        this.css(this.dock, '--bpr-dock-height', `${this.dockHeight}px`);
        this.css(document.body, '--bpr-dock-space', `${this.dockHeight}px`);
      }
      this.syncChatOffset(nativeRect, visible, overlay || keyboard);
      if (this.cartWasOpen && !cartOpen && this.restoreDockFocus) {
        const active = document.activeElement;
        if (visible && (active === document.body || active?.closest('cart-drawer, cart-notification') || active === state.button)) {
          const target = !this.addButton.disabled ? this.addButton
            : this.editButton && !this.editButton.hidden ? this.editButton
              : this.quantityPlus && !this.quantityPlus.disabled ? this.quantityPlus
                : this.quantityMinus && !this.quantityMinus.disabled ? this.quantityMinus : this.dock;
          if (target === this.dock) this.attribute(this.dock, 'tabindex', '-1');
          target.focus({ preventScroll: true });
        }
        this.restoreDockFocus = false;
        this.submittedHere = false;
      }
      this.cartWasOpen = cartOpen;
    }

    resetChatOffset() {
      if (document.body.classList.contains('bpr-chat-offset')) document.body.classList.remove('bpr-chat-offset');
      if (document.body.style.getPropertyValue('--bpr-chat-bottom')) document.body.style.removeProperty('--bpr-chat-bottom');
    }

    syncChatOffset(nativeRect, dockVisible, suppressed) {
      const launcher = document.querySelector('#reamaze-widget');
      if (suppressed || !this.isVisible(launcher)) { this.resetChatOffset(); return; }
      const bounds = launcher.getBoundingClientRect();
      // Use its unmoved fixed-position baseline, not the shifted Y, to avoid oscillation.
      const baselineBottom = window.innerHeight - 22;
      const baselineTop = baselineBottom - bounds.height;
      const horizontalOverlap = nativeRect.left < bounds.right && nativeRect.right > bounds.left;
      const nativeOverlap = nativeRect.top < baselineBottom + 8 && nativeRect.bottom > baselineTop - 8;
      let bottom = dockVisible ? this.dockHeight + 22 : 22;
      if (!dockVisible && horizontalOverlap && nativeOverlap) {
        bottom = Math.max(22, window.innerHeight - nativeRect.top + 8);
      }
      if (bottom > 22) {
        this.css(document.body, '--bpr-chat-bottom', `${Math.ceil(bottom)}px`);
        if (!document.body.classList.contains('bpr-chat-offset')) document.body.classList.add('bpr-chat-offset');
      } else {
        this.resetChatOffset();
      }
    }

    setVisible(visible) {
      if (this.dock.hidden !== !visible) this.dock.hidden = !visible;
      if (this.dock.inert !== !visible) this.dock.inert = !visible;
      if (document.body.classList.contains('bpr-dock-active') !== visible) document.body.classList.toggle('bpr-dock-active', visible);
      if (!visible && document.body.style.getPropertyValue('--bpr-dock-space') !== '0px') document.body.style.setProperty('--bpr-dock-space', '0px');
    }

    submit() {
      const state = this.nativeState();
      if (!state || state.disabled || state.busy || this.submitQueued || this.addButton.disabled) return;
      if (state.quantity && !state.quantity.checkValidity()) {
        this.edit(state.quantity);
        state.quantity.reportValidity();
        return;
      }
      if (!state.form.reportValidity()) return;
      this.localError = '';
      this.submittedHere = true;
      this.submitQueued = true;
      this.sawNativeBusy = false;
      this.addButton.focus({ preventScroll: true });
      this.text(this.labelNode, this.dataset.addingLabel || 'Adding…');
      state.button.click();
      this.addButton.disabled = true;
      this.sawNativeBusy = state.button.classList.contains('loading');
      this.schedule();
      clearTimeout(this.submitTimer);
      this.submitTimer = setTimeout(() => {
        const current = this.nativeState();
        if (!current?.busy) { this.submitQueued = false; this.schedule(); }
      }, 1200);
    }

    edit(target) {
      const state = this.nativeState();
      if (!state) return;
      const focus = target instanceof HTMLElement ? target
        : state.info.querySelector('variant-selects select, variant-selects input:checked, variant-selects input') || state.quantity || state.button;
      const area = focus.closest('variant-selects, .product-form__quantity') || focus;
      const header = document.querySelector('sticky-header');
      const inset = header && this.isVisible(header) ? Math.max(0, header.getBoundingClientRect().bottom) + 20 : 100;
      const top = area.getBoundingClientRect().top + window.scrollY - inset;
      window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      focus.focus({ preventScroll: true });
      this.schedule();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      if (this.frame) cancelAnimationFrame(this.frame);
      clearTimeout(this.submitTimer);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.unsubscribers?.forEach((unsubscribe) => { if (typeof unsubscribe === 'function') unsubscribe(); });
      this.restoreErrorReporter();
      this.dock?.remove();
      if (!document.querySelector('.bpr-dock:not([hidden])')) {
        document.body.classList.remove('bpr-dock-active');
        document.body.style.removeProperty('--bpr-dock-space');
        this.resetChatOffset();
      }
      this.frame = null;
      this.submitQueued = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bash-premium-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bash-premium-footer')) {
  customElements.define('bash-premium-footer', class extends HTMLElement {
    connectedCallback() {
      if (this.bfReady) return;
      this.bfReady = true;
      this.frame = this.querySelector('.bf-frame');
      this.toolbar = this.querySelector('.bf-preview');
      this.onHash = () => this.applyPreview(true);
      window.addEventListener('hashchange', this.onHash);
      this.querySelectorAll('[data-bf-width]').forEach(button => button.addEventListener('click', () => {
        history.replaceState(null, '', this.previewUrl('#footer-preview-' + this.dataset.design + '-' + button.dataset.bfWidth));
        this.applyPreview(true);
      }));
      this.querySelectorAll('[data-bf-design]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        history.replaceState(null, '', this.previewUrl('#footer-preview-' + link.dataset.bfDesign + '-' + (this.dataset.width || 'desktop')));
        this.applyPreview(true);
      }));
      this.querySelector('.bf-preview__close')?.addEventListener('click', () => {
        history.replaceState(null, '', location.pathname + location.search);
        this.applyPreview(false);
      });
      this.querySelectorAll('.bf-links summary').forEach(summary => summary.addEventListener('click', event => {
        if (this.wide) event.preventDefault();
      }));
      this.querySelectorAll('.bf-region').forEach(form => form.addEventListener('submit', () => {
        const theme = window.Shopify?.theme;
        if (this.dataset.editor === 'true' || !theme?.id || !['unpublished', 'development'].includes(theme.role)) return;
        const returnTo = form.elements.namedItem('return_to');
        if (!returnTo) return;
        const url = new URL(location.href);
        url.searchParams.set('preview_theme_id', String(theme.id));
        returnTo.value = url.pathname + url.search + url.hash;
      }));
      this.querySelectorAll('.bf-region select').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
      this.observer = new ResizeObserver(entries => {
        const wide = entries[0].contentRect.width >= 700 || this.dataset.accordion !== 'true';
        if (wide === this.wide) return;
        this.wide = wide;
        this.querySelectorAll('.bf-links').forEach(details => {
          details.open = wide;
          const summary = details.querySelector('summary');
          summary.tabIndex = wide ? -1 : 0;
          if (wide) summary.setAttribute('aria-disabled', 'true'); else summary.removeAttribute('aria-disabled');
        });
      });
      this.observer.observe(this.frame);
      this.applyPreview(false);
      if (this.toolbar && location.hash.startsWith('#footer-preview-')) {
        this.onLoad = () => this.scrollIntoView({block:'start'});
        requestAnimationFrame(this.onLoad);
        if (document.readyState !== 'complete') window.addEventListener('load', this.onLoad, {once:true});
      }
    }
    previewUrl(hash) {
      const url = new URL(location.href);
      url.hash = hash;
      const theme = window.Shopify?.theme;
      if (theme?.id && theme.role === 'unpublished' && this.dataset.editor !== 'true') {
        url.searchParams.set('preview_theme_id', String(theme.id));
      }
      return url;
    }
    applyPreview(scroll) {
      const match = this.toolbar ? location.hash.match(/^#footer-preview-(stone|midnight|minimal)(?:-(desktop|tablet|mobile))?$/) : null;
      const enabled = Boolean(match);
      this.dataset.preview = String(enabled);
      if (this.toolbar) this.toolbar.hidden = !enabled;
      this.dataset.design = match ? match[1] : this.dataset.defaultDesign;
      this.dataset.width = match ? match[2] || 'desktop' : 'desktop';
      this.querySelectorAll('[data-bf-design]').forEach(link => {
        link.setAttribute('aria-current', String(link.dataset.bfDesign === this.dataset.design));
        link.href = this.previewUrl('#footer-preview-' + link.dataset.bfDesign + '-' + this.dataset.width);
      });
      this.querySelectorAll('[data-bf-width]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bfWidth === this.dataset.width)));
      if (scroll && match) this.scrollIntoView({block:'start'});
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('hashchange', this.onHash);
      if (this.onLoad) window.removeEventListener('load', this.onLoad);
      this.bfReady = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bash-search-studio"] && !Shopify.designMode) return;
  try {
    
(() => {
  const elementName = 'bash-search-studio';
  const registryKey = Symbol.for('bash.searchStudio.facets');
  const widthPattern = /^#search-preview-(desktop|tablet|mobile)$/;
  const searchPathPattern = /\/search\/?$/;
  const resultLinkSelector = '#ProductGridContainer .pagination-wrapper, facet-remove, #ProductGridContainer .collection--empty';

  if (customElements.get(elementName)) return;

  class BashSearchStudio extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return;
      this._main = this.closest('main');
      if (!this._main) return;

      this._mounted = true;
      const lifecycle = new AbortController();
      this._lifecycle = lifecycle;
      this._createdInputs = new Set();
      const current = new URL(window.location.href);
      this._pathname = current.pathname;
      this._context = new Map();
      this._constraints = new Map();
      for (const key of ['view', 'pb', 'preview_theme_id']) {
        if (current.searchParams.has(key)) this._context.set(key, current.searchParams.get(key));
      }
      for (const key of ['type', 'options[prefix]']) {
        if (current.searchParams.has(key)) this._constraints.set(key, current.searchParams.get(key));
      }
      this._query = current.searchParams.get('q');

      this._main.addEventListener('click', (event) => this._onClick(event), { signal: lifecycle.signal });
      document.addEventListener('submit', (event) => this._onSubmit(event), {
        capture: true,
        signal: lifecycle.signal,
      });
      window.addEventListener('hashchange', () => this._syncWidth(), { signal: lifecycle.signal });
      window.addEventListener('popstate', () => this._syncWidth(), { signal: lifecycle.signal });

      this._observer = new MutationObserver(() => this._scheduleDecorations());
      this._observer.observe(document.body, { childList: true, subtree: true });
      this._resizeObserver = new ResizeObserver(() => this._syncDevice());
      this._resizeObserver.observe(this._main);
      this._syncWidth();
      this._decorateForms();
      this._decorateLinks();

      customElements.whenDefined('facet-filters-form').then(() => {
        if (lifecycle.signal.aborted || !this.isConnected || !this._mounted) return;
        this._attachFacets(customElements.get('facet-filters-form'));
      });
    }

    disconnectedCallback() {
      if (!this._mounted) return;
      this._mounted = false;
      this._lifecycle.abort();
      this._observer.disconnect();
      this._resizeObserver.disconnect();
      if (this._decorationFrame) cancelAnimationFrame(this._decorationFrame);
      this._decorationFrame = 0;
      this._createdInputs.forEach((input) => input.remove());
      this._createdInputs.clear();

      const registry = this._facetRegistry;
      if (registry) {
        registry.owners.delete(this);
        if (!registry.owners.size) {
          if (registry.Facets.renderPage === registry.wrappedRender) registry.Facets.renderPage = registry.originalRender;
          if (registry.Facets.updateURLHash === registry.wrappedUpdate) registry.Facets.updateURLHash = registry.originalUpdate;
        }
      }
      this._facetRegistry = null;
      if (!this._main.querySelector(elementName)) {
        delete this._main.dataset.bsWidth;
        delete this._main.dataset.bsDevice;
      }
    }

    _onClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      const control = target?.closest('[data-bs-width], .bs-close');
      if (!control || !control.closest('.bs-preview') || !this._main.contains(control)) return;
      const width = control.dataset.bsWidth;
      if (!control.classList.contains('bs-close') && !['desktop', 'tablet', 'mobile'].includes(width)) return;
      event.preventDefault();
      const url = new URL(window.location.href);
      url.hash = control.classList.contains('bs-close') ? '' : `search-preview-${width}`;
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      this._syncWidth();
    }

    _onSubmit(event) {
      const form = event.target;
      if (form instanceof HTMLFormElement && this._isSearchForm(form)) this._decorateForm(form);
    }

    _syncWidth() {
      const width = window.location.hash.match(widthPattern)?.[1];
      if (width) this._main.dataset.bsWidth = width;
      else delete this._main.dataset.bsWidth;
      this._main.querySelectorAll('.bs-preview').forEach((controls) => {
        controls.hidden = !width;
        controls.querySelectorAll('[data-bs-width]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.bsWidth === width));
        });
      });
      this._syncDevice();
      this._scheduleDecorations();
    }

    _syncDevice() {
      if (!this._mounted) return;
      const width = this._main.getBoundingClientRect().width;
      const device = width < 750 ? 'mobile' : width < 1050 ? 'tablet' : 'desktop';
      if (this._main.dataset.bsDevice !== device) this._main.dataset.bsDevice = device;
    }

    _preservePreviewParams(searchParams) {
      const params = new URLSearchParams(searchParams || '');
      for (const [key, value] of this._context) params.set(key, value);
      return params;
    }

    _preserveFacetParams(searchParams) {
      const params = this._preservePreviewParams(searchParams);
      for (const [key, value] of this._constraints) params.set(key, value);
      if (this._query !== null) params.set('q', this._query);
      return params;
    }

    _isSearchUrl(url) {
      return url.origin === window.location.origin && searchPathPattern.test(url.pathname);
    }

    _isSearchForm(form) {
      if (form.method.toLowerCase() !== 'get' || !form.querySelector('input[name="q"]')) return false;
      return this._isSearchUrl(new URL(form.action, window.location.href));
    }

    _decorateForm(form) {
      for (const [name, value] of this._context) {
        if (Array.from(form.elements).some((input) => input.name === name)) continue;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        this._createdInputs.add(input);
        form.append(input);
      }
    }

    _decorateForms() {
      document.querySelectorAll('form[action]').forEach((form) => {
        if (this._isSearchForm(form)) this._decorateForm(form);
      });
    }

    _scheduleDecorations() {
      if (!this._mounted || this._decorationFrame) return;
      this._decorationFrame = requestAnimationFrame(() => {
        this._decorationFrame = 0;
        if (!this._mounted) return;
        this._decorateForms();
        this._decorateLinks();
      });
    }

    _decorateLinks() {
      document.querySelectorAll('main a[href], predictive-search a[href]').forEach((anchor) => {
        const url = new URL(anchor.href, window.location.href);
        if (!this._isSearchUrl(url)) return;
        const isResultAction = this._main.contains(anchor) && anchor.closest(resultLinkSelector);
        url.search = (isResultAction ? this._preserveFacetParams(url.searchParams) : this._preservePreviewParams(url.searchParams)).toString();
        if (anchor.closest('facet-remove')) url.hash = '';
        else if (widthPattern.test(window.location.hash)) url.hash = window.location.hash;
        else if (widthPattern.test(url.hash)) url.hash = '';
        if (anchor.href !== url.href) anchor.href = url.href;
      });
    }

    _attachFacets(Facets) {
      if (typeof Facets?.renderPage !== 'function' || typeof Facets.updateURLHash !== 'function') return;
      let registry = Facets[registryKey];
      if (!registry) {
        registry = {
          Facets,
          owners: new Set(),
          originalRender: Facets.renderPage,
          originalUpdate: Facets.updateURLHash,
        };
        const activeOwner = () => Array.from(registry.owners).reverse().find((owner) => (
          owner._mounted && owner.isConnected && owner._pathname === window.location.pathname
        ));
        registry.wrappedRender = function (searchParams, event, updateURLHash = true) {
          const owner = activeOwner();
          const params = owner ? owner._preserveFacetParams(searchParams).toString() : searchParams;
          return registry.originalRender.call(this, params, event, updateURLHash);
        };
        registry.wrappedUpdate = function (searchParams) {
          const owner = activeOwner();
          const hash = owner ? window.location.hash : '';
          const params = owner ? owner._preserveFacetParams(searchParams).toString() : searchParams;
          const result = registry.originalUpdate.call(this, params);
          if (hash && window.location.hash !== hash) {
            const url = new URL(window.location.href);
            url.hash = hash;
            history.replaceState(history.state, '', url.pathname + url.search + url.hash);
          }
          return result;
        };
        Facets[registryKey] = registry;
      }
      registry.owners.add(this);
      if (Facets.renderPage === registry.originalRender) Facets.renderPage = registry.wrappedRender;
      if (Facets.updateURLHash === registry.originalUpdate) Facets.updateURLHash = registry.wrappedUpdate;
      this._facetRegistry = registry;
    }
  }

  customElements.define(elementName, BashSearchStudio);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.resizeObserver.observe(this.header);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.createObserver();
    }
    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      if (!this.searchModal) this.searchModal = this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
